import { Box, GitFork, House, Link2, Router, Server, UtilityPole, Wifi, type LucideIcon } from 'lucide-react';

const MARKER: Record<string, { cls: string; icon?: LucideIcon }> = {
  OLT: { cls: 'olt', icon: Server },
  SERVER: { cls: 'server', icon: Router },
  AP: { cls: 'ap', icon: Wifi },
  ODC: { cls: 'odc', icon: Box },
  ODP: { cls: 'odp', icon: GitFork },
  JC: { cls: 'jc', icon: Link2 },
  POLE: { cls: 'pole' },
  CPE: { cls: 'cpe' },
};

/** Small AssetMarker (design system) for tables and legends. */
export function AssetGlyph({ type }: { type: string }) {
  const m = MARKER[type] ?? { cls: 'odp' };
  const Icon = m.icon;
  return (
    <span className={`fn-marker fn-marker--${m.cls}`} aria-hidden style={{ cursor: 'default' }}>
      {Icon && <Icon className="i" />}
    </span>
  );
}

export const TYPE_ICON: Record<string, LucideIcon> = {
  OLT: Server,
  SERVER: Router,
  AP: Wifi,
  ODC: Box,
  ODP: GitFork,
  JC: Link2,
  POLE: UtilityPole,
  CPE: House,
};
